import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { PlatformSectionService } from '../platform-section.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-add-platform-section',
  templateUrl: './add-platform-section.component.html',
  styleUrls: ['./add-platform-section.component.scss']
})
export class AddPlatformSectionComponent {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error;
  errorIcon: string = environment.config.customNotifications.icons.error;
  errorType: string = environment.config.customNotifications.icons.error;

  token!: string;
  isLoading = false;
  form: FormGroup = new FormGroup({
    name: new FormControl(''),
    slug: new FormControl(''),
    observations: new FormControl(''),
    active_message: new FormControl(''),
  });

  constructor(
    private dialogRef: MatDialogRef<AddPlatformSectionComponent>,
    private platformSectionService: PlatformSectionService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true,
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token;
      this.platformSectionService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const platformSection = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      observations: this.form.get('observations')?.value,
      active_message: this.form.get('active_message')?.value,
    };

    this.platformSectionService
      .addPlatformSection(platformSection)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (res) => {
          this.dialogRef.close({ success: true });
        },
        error: (err) => {
          let errorMessage =
            environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(
            this.errorTitle,
            errorMessage,
            this.errorIcon
          );
        },
      });
  }
}
